import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=59473d2c&scoped=true&"
import script from "./MessageHeader.vue?vue&type=script&lang=js&"
export * from "./MessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessageHeader.vue?vue&type=style&index=0&id=59473d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59473d2c",
  null
  
)

export default component.exports